import { format } from 'date-fns';

// Map IANA timezone names to [standard, daylight] abbreviations
const TIMEZONE_ABBREVIATIONS: Record<string, [string, string]> = {
  // US
  'America/New_York': ['EST', 'EDT'],
  'America/Chicago': ['CST', 'CDT'],
  'America/Denver': ['MST', 'MDT'],
  'America/Phoenix': ['MST', 'MST'],
  'America/Los_Angeles': ['PST', 'PDT'],
  'America/Anchorage': ['AKST', 'AKDT'],
  'Pacific/Honolulu': ['HST', 'HST'],
  // Canada
  'America/Toronto': ['EST', 'EDT'],
  'America/Vancouver': ['PST', 'PDT'],
  // Asia
  'Asia/Tokyo': ['JST', 'JST'],
  'Asia/Shanghai': ['CST', 'CST'],
  'Asia/Hong_Kong': ['HKT', 'HKT'],
  'Asia/Seoul': ['KST', 'KST'],
  'Asia/Singapore': ['SGT', 'SGT'],
  'Asia/Kolkata': ['IST', 'IST'],
  // Australia
  'Australia/Sydney': ['AEST', 'AEDT'],
  'Australia/Melbourne': ['AEST', 'AEDT'],
  'Australia/Perth': ['AWST', 'AWST'],
  // Europe
  'Europe/London': ['GMT', 'BST'],
  'Europe/Paris': ['CET', 'CEST'],
  'Europe/Berlin': ['CET', 'CEST'],
  'Europe/Moscow': ['MSK', 'MSK'],
  // UTC
  UTC: ['UTC', 'UTC'],
  'Etc/UTC': ['UTC', 'UTC'],
};

function isDST(date: Date): boolean {
  const jan = new Date(date.getFullYear(), 0, 1);
  const jul = new Date(date.getFullYear(), 6, 1);
  const standardOffset = Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
  return date.getTimezoneOffset() < standardOffset;
}

function getGMTOffset(date: Date): string {
  const offset = date.getTimezoneOffset();
  if (offset === 0) return 'GMT';
  const sign = offset <= 0 ? '+' : '-';
  const hours = Math.floor(Math.abs(offset) / 60);
  const mins = Math.abs(offset) % 60;
  return mins === 0 ? `GMT${sign}${hours}` : `GMT${sign}${hours}:${String(mins).padStart(2, '0')}`;
}

function getTimezoneAbbreviation(date: Date): string {
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const abbrs = TIMEZONE_ABBREVIATIONS[tz];
  if (abbrs) {
    return isDST(date) ? abbrs[1] : abbrs[0];
  }
  return getGMTOffset(date);
}

export function formatDate(date: string | Date): string | undefined {
  if (date) {
    const d = new Date(date);
    const dateStr = format(d, 'yyyy-MM-dd HH:mm:ss');
    return `${dateStr} ${getTimezoneAbbreviation(d)}`;
  }
}
